import {Slider} from '../slider/slider.js'
import {RangeSlider} from "../range-slider/range-slider";

class Filter {

  constructor(elem) {
    this.filter = elem;
    this.title = this.filter.find('[data-filter-title]');
    this.button = this.filter.find('[data-filter-button]');
    this.reset = $('[data-filter-reset]');
    this.checkbox = this.filter.find('[data-filter-checkbox]');
    this.radio = this.filter.find('[data-filter-radio]');
    this.range = this.filter.find('[data-filter-range]');
    this.btnHide = $('[data-filter-hide]');
    this.result = $('[data-filter-result]');
    this.nav = $('[data-filter-nav]');
    this.navBtn = this.nav.find('[data-filter-nav-btn]');
    this.catalog = $('[data-catalog]');
    this.btnOpen = $('[data-filter-open]');
    this.btnApply = $('[data-filter-apply]');
    this.changeSex = this.filter.find('[data-change-sex]');
    this.setSex = $('[data-change-sex-set]');
    this.pagination = $('[data-pagination-container]');
    this.youViewed = $('[data-you-viewed]');
    this.sort = this.filter.find('input[name="sort"]');
    this.selectSort = $('[data-sort]').find('select');
  }

  initialize() {
    let sliders = [];
    let that = this;

    if ($('[data-slider-gallery]').length > 0) {
      $('[data-slider-gallery]').each(function(i) {
        sliders[i] = new Slider($(this));
      });
    }

    this.filter.on('submit', function(e) {
      e.preventDefault();
    })

    // проверка наличия баннера в каталоге
    if (this.catalog.find('.banner-catalog').length > 0) {
      this.setCardsWithBannerClass();

      $(window).on('resize', this.setCardsWithBannerClass.bind(this))
    }

    // скрытие и открытие блоков фильтра
    this.title.on('click', (e) => {
      let $el = $(e.target);
      // let el = e.target;

      let content = $el.parent().find('[data-filter-content]');

      $el.toggleClass('active');
      content.slideToggle('fast');
    });

    // выбор фильтра модели, размеры и т.д
    this.button.on('click', (e) => {
      let el = e.target;
      el.classList.toggle('selected');

      this.addFilter(el);
      this.isReset();
      this.applyFilter();

      e.preventDefault();
    });

    // выбор фильтра чекбокса
    this.checkbox.on('click', (e) => {
      let el = e.target;
      let param = $(el).attr('data-filter-checkbox');
      el.classList.toggle('selected');
      if(param = 'price'){
        window.checkbox_price_id = $(el).attr('id')
      }

      this.addFilter(el);
      this.isReset();
      this.applyFilter(param);

      e.preventDefault();
    });

    // выбор фильтра через радио кнопки
    this.radio.on('click', (e) => {
      let el = e.target;
      el.classList.toggle('selected');

      this.addFilter(el);
      this.isReset();
      this.applyFilter();

      e.preventDefault();
    });

    // сброс фильтра
    this.reset.on('click', (e) => {
      let that = this;
      let $form = $('[data-filter]');
      let action = $form.attr('action');
      let sort = 'default';

      this.sort.each(function(key, value) {
        if ($(value).attr('checked') === 'checked') {
          sort = $(value).val();
        }
      });

      // delete PAGEN & SHOWALL params
      action = this.clearPagination(action);

      if (window.xhr_reset_filter && window.xhr_reset_filter.readyState != 4) {
        window.xhr_reset_filter.abort();
      }

      $('[data-preloader]').fadeIn('slow');

      window.xhr_reset_filter = $.ajax({
        type    : 'GET',
        url     : action,
        data    : 'clear_filter=Y&apply_filter=Y&ajax=Y&sort=' + sort,
        success : function(data) {
          that.fillCatalogFromHtml(data);

          Jamilco.removeParamFromURL(action);
          if (sort !== 'default') {
            history.pushState('', '', Jamilco.addParamToURL(action, 'sort', sort));
          }

          //удаление полоски фильтров
          $('[data-filter-href]').remove();

          $('[data-preloader]').fadeOut('slow');
        }
      })
    });

    // скрытие / отображение фильтра
    this.btnHide.on('click', this.hideFilter.bind(this))
    // this.btnHide.off('click').on('click', (e) => {
    //   let el = e.target;

    //   this.filter.parent().toggleClass('d-none');

    //   el.closest('[data-page-content]').classList.toggle('col-md-9');
    //   el.closest('[data-page-content]').querySelector('[data-filter-result]').classList.toggle('d-none');

    //   let path = process.env.NODE_ENV === 'development' ? '/' : '/local/frontend/build/'

    //   if (this.filter.parent().hasClass('d-none')) {
    //     el.innerHTML = `<svg class="icon filter " aria-hidden="true"><use xlink:href="${path}assets/images/required/sprite.svg#filter"></use></svg> Показать фильтр`
    //   } else {
    //     el.innerHTML = `<svg class="icon filter " aria-hidden="true"><use xlink:href="${path}assets/images/required/sprite.svg#filter"></use></svg> Скрыть фильтр`;
    //   }

    //   if (this.filter.parent().hasClass('d-none')) {
    //     if (this.reset.hasClass('show')) {
    //       this.result.removeClass('d-none');
    //     } else {
    //       this.result.addClass('d-none');
    //     }

    //   } else {
    //     if (!this.reset.hasClass('show')) {
    //       this.result.addClass('d-none');
    //     }
    //   }
    // });

    // выбор режима отображения карточек
    $(document).on('click', '[data-filter-nav-btn]', function(e) {
      let el = e.target;
      let $el = $(e.target);

      $(document).find('[data-filter-nav-btn]').removeClass('active');
      $(document).find('[data-filter-nav-btn]').prop("disabled", false);

      el.closest('button').classList.add('active');
      el.closest('button').disabled = true;
      if($el.closest('button').data('line-count') == '1'){
        $(document).find('[data-catalog]').children().not('.not-col-6').removeClass('col-6');
      }else{
        $(document).find('[data-catalog]').children().not('.not-col-6').addClass('col-6');
      }

      if ($('[data-slider-gallery]').length > 0) {
        $('[data-slider-gallery]').each(function(i) {
          sliders[i].sliderArrow($(this));
        });
      }
    });

    // открытие фильтра на мобильных и планшетах
    this.btnOpen.on('click', (e) => {
      this.filter.slideDown('fast');
      this.filter.addClass('active');
      $('body').addClass('overflow');
      $('html').addClass('overflow');

      e.preventDefault();
    });

    $(window).on('resize', () => {
      this.filter.removeAttr('style');

      if ($(window).width() < 992) {
        this.filter.parent().removeClass('d-none');
        $('[data-page-content]').addClass('col-md-9');
      }
    });

    // отправка примененных фильтров на бек для фильтрации
    this.btnApply.on('click', (e) => {
      let el = e.target;
      let filterForm = el.closest('form')
      let _ajax = this.btnApply.data('ajax');

      _ajax = $.ajax({
        url      : '/local/ajax/example.php',
        method   : 'post',
        dataType : '',
        data     : {}
      }).done(function(response) {
        console.log('success')
      }).fail(function(response) {
        console.log('fail')
        if (process.env.NODE_ENV === 'development') {
          $(el).closest('[data-filter]').removeClass('active')
          $('html, body').animate({scrollTop : $(filterForm).offset().top + 250 + 'px'}, 500);
        }
      })

      $('body').removeClass('overflow');
      $('html').removeClass('overflow');
    });

    $(document).on('click', '[data-filter-href] .icon', (e) => {
      let el = e.target.closest('[data-filter-href]');
      let href = el.getAttribute('data-filter-href');

      let option = this.filter.find(`[name='${href}']`);
      option.closest('[data-role]').removeClass('selected');
      option.removeAttr('checked');

      el.remove();

      this.isReset();
      this.applyFilter();

      let selected = this.filter.find('.selected').length;

      if (selected < 1) {
        this.result.addClass('d-none');
      } else {
        this.result.removeClass('d-none');
      }
    });

    //Сортировка
    this.selectSort.on('change', (e) => {
      let $el = $(e.target);
      let sortType = $el.val();

      this.sort.each(function(key,value){
        if ($(value).val() === sortType) {
          $(value).attr('checked', 'checked');
        } else {
          $(value).removeAttr('checked');
        }
      });

      this.isReset();
      this.applyFilter();
      e.preventDefault();
    });

    // выбор пола в фильтре
    this.changeSex.on('click', () => {
      let popup = this.filter.find('[href="#popup-sex"]');
      let text = popup.text();
      let classPopup = popup.attr('class');

      let template = `<button class="${classPopup}" type="button" data-filter-title="">${text}</button>`;

      if (popup.length > 0) {
        popup.parent().prepend(template);
        popup.remove();
      }
    });

    // сохранение после выбора данных в попапе
    this.setSex.on('change', function() {
      let popup = that.filter.find('[href="#popup-sex"]');
      let text = popup.text();
      let classPopup = popup.attr('class');
      let radio = that.filter.find('[data-change-sex]');
      let index = $(this).parent().parent().index();

      let template = `<button class="${classPopup}" type="button" data-filter-title="">${text}</button>`;

      if (popup.length > 0) {
        radio.parent().parent().eq(index).find('input').trigger('click')
        popup.parent().prepend(template);
        popup.remove();

        $.magnificPopup.close();
      }
    });

    // проверка, надо ли показывать кнопку сброса фильтра
    this.isReset();

    // проставление выбранных фильтров в верхнюю строку в каталоге
    if ($('[data-page-content]').attr('data-load-page') == 'N') {
      let input = $(document).find('[data-filter-button] input:checked').parent();
      let checkboxColor = $(document).find('[data-filter-checkbox]:checked').parent();
      input.each((i) => {
        let el = input[i]
        this.addFilter(el);
      });
      checkboxColor.each((i) => {
        let el = checkboxColor[i]
        this.addFilter(el);
      });
      $('[data-page-content]').attr('data-load-page', 'Y')
    }

    this.checkSizeFilter();
  }

  // скрытие фильтра
  hideFilter(e) {
    let el = e.target;

    this.filter.parent().toggleClass('d-none');

    el.closest('[data-page-content]').classList.toggle('col-md-9');
    el.closest('[data-page-content]').querySelector('[data-filter-result]').classList.toggle('d-none');

    let path = process.env.NODE_ENV === 'development' ? '/' : '/local/frontend/build/'

    if (this.filter.parent().hasClass('d-none')) {
      el.innerHTML = `<svg class="icon filter " aria-hidden="true"><use xlink:href="${path}assets/images/required/sprite.svg#filter"></use></svg> ` + BX.message('PM_CATALOG_FILTER_SHOW')
    } else {
      el.innerHTML = `<svg class="icon filter " aria-hidden="true"><use xlink:href="${path}assets/images/required/sprite.svg#filter"></use></svg> ` + BX.message('PM_CATALOG_FILTER_HIDE');
    }

    if (this.filter.parent().hasClass('d-none')) {
      if (this.reset.hasClass('show')) {
        this.result.removeClass('d-none');
      } else {
        this.result.addClass('d-none');
      }

    } else {
      if (!this.reset.hasClass('show')) {
        this.result.addClass('d-none');
      }
    }
  }

  // проверка, есть ли выбранные пользователем фильтры
  isReset() {
    let selected = this.filter.find('.selected,.radio__input[checked="checked"]').length;

    if (selected < 1) {
      this.reset.removeClass('show');
    } else {
      this.reset.addClass('show');
    }
  }

  applyFilter(checkboxType = '') {
    let that = this;

    $('[data-preloader]').fadeIn('slow');
    if ($(window).width() > 640) {
      this.reloadCatalog(checkboxType);
    } else {
      var req = 'ajax=Y&set_filter=Показать&' + $('form[name="_form"]').serialize();
      req = this.clearPaginationInParams(req);
      req = this.preparePriceParams(req);

      var $form = $('[data-filter]');
      var action = $form.attr('action');
      var dataSerialize = $form.serialize() + '&set_filter=Показать';

      if (process.env.NODE_ENV === 'development') $('[data-preloader]').fadeIn('slow');

      if (action.indexOf('/?') === -1) action = action + '?';

      // delete PAGEN & SHOWALL params
      action = this.clearPagination(action);
      dataSerialize = this.clearPaginationInParams(dataSerialize);
      dataSerialize = this.preparePriceParams(dataSerialize);

      if (window.xhr_apply_filter && window.xhr_apply_filter.readyState != 4) {
        window.xhr_apply_filter.abort();
      }

      window.xhr_apply_filter = $.ajax({
        url     : (window.filterBaseUrl) ? window.filterBaseUrl : window.location.pathname,
        type    : 'GET',
        data    : req,
        success : function(data) {
          let countInCatalog = $(data).find('#count_in_catalog_total').val();

          that.fillCatalogFromHtml(data, checkboxType);

          Jamilco.removeParamFromURL(action + dataSerialize);

          //нужно чтобы отрабатыввало переключение отображения каталога после фильтрации
          $(document).find('[data-filter-nav-btn]').off('click')
          $('[data-filter-href] .icon').off('click')
          that.navBtn.removeClass('active').prop("disabled", false);
          $(that.navBtn[0]).addClass('active').prop("disabled", true);
          // количество отфильтрованных товаров
          var countButton = $('.show-selected-items');
          var successMsg = $('.show-selected-items .success');
          var errorMsg = $('.show-selected-items .error');

          $('.show-select-items__count').text(countInCatalog);
          countButton.addClass('active'); // вкл. возможность перехода к товарам по клику
          successMsg.show();
          errorMsg.hide();

          if (countInCatalog > 0) {

          } else {
            //countButton.removeClass('active'); // выкл. возможность перехода к товарам по клику
            successMsg.hide();
            errorMsg.show();
          }

          countButton.fadeIn();
          $('[data-preloader]').fadeOut('slow');
        },
        error   : function(res) {
          console.log(res);
        }
      });
    }
  }

  reloadCatalog(checkboxType = '') {
    let that = this;
    var $form = $('[data-filter]');
    var action = $form.attr('action');
    var dataSerialize = $form.serialize() + '&set_filter=Показать';

    if (process.env.NODE_ENV === 'development') $('[data-preloader]').fadeOut('slow');

    if (action.indexOf('/?') === -1) action = action + '?';

    // delete PAGEN & SHOWALL params
    action = this.clearPagination(action);
    dataSerialize = this.clearPaginationInParams(dataSerialize);
    dataSerialize = this.preparePriceParams(dataSerialize);

    if (window.xhr_reload_catalog && window.xhr_reload_catalog.readyState != 4) {
      window.xhr_reload_catalog.abort();
    }

    window.xhr_reload_catalog = $.ajax({
      type    : 'GET',
      url     : action,
      data    : dataSerialize + '&ajax=Y',
      success : function(data) {
        that.fillCatalogFromHtml(data, checkboxType);

        Jamilco.removeParamFromURL(action + dataSerialize);

        $('[data-preloader]').fadeOut('slow');
      },
      error   : function(xhr, str) {
        console.log(xhr.responseCode);
        if (xhr.status != 0) {
          $('[data-preloader]').fadeOut('slow');
        }
      }
    })
  }

  // добавление класса для карточек с баннером
  setCardsWithBannerClass() {
    this.catalog.find('.card--catalog').removeClass('card--catalog-banner');
    let cardsAmount = this.catalog.find('.banner-catalog').parent().filter(elem => !$(elem).hasClass('.not-col-6')).length
    let maxCardsAmount = $(window).width() > 992 ? 3 : 2

    cardsAmount = maxCardsAmount - cardsAmount;

    let currentCards = this.catalog.find('.card--catalog').slice(0, cardsAmount);
    let currentCardsTitles = currentCards.find('.card__title');

    currentCardsTitles.attr('style', '');
    let currentCardsTitlesHeight = [];
    currentCardsTitles.each(function() {
      currentCardsTitlesHeight.push($(this).height());
    })
    currentCardsTitlesHeight = Math.max(...currentCardsTitlesHeight);
    currentCardsTitles.css({'height': `${currentCardsTitlesHeight}px`})

    currentCards.addClass('card--catalog-banner');
  }

  fillCatalogFromHtml(catalogHtml, checkboxType = '') {
    const that = this;
    let $data = $(catalogHtml);
    let filterContent = $data.find('[data-filter]');
    let catalogContent = $data.find('[data-catalog]');
    let youViewedContent = $data.find('[data-you-viewed]');
    let paginationContent = $data.find('[data-pagination-container]');
    let countInCatalog = $data.find('#count_in_catalog_total').val();
    let priceOldBlock = $(document).find('[data-filter-price]');
    let sort = $data.find('[data-sort]');

    this.filter.html(filterContent.html());
    this.catalog.html(catalogContent.html());
    this.youViewed.html(youViewedContent.html());
    this.pagination.html(paginationContent.html());
    this.sort.find('form').attr('action', sort.find('form').attr('action'));

    this.pagination.show();
    if (paginationContent.css('display')) {
      this.pagination.css('display', paginationContent.css('display'));
    }

    let img = this.catalog.find('.lazyload');
    let lazy = new LazyLoad(img);
    lazy.loadImages();

    //установка количества наденного в каталоге
    $('.js-catalog-items-count').text(countInCatalog);

    this.checkSizeFilter();

    // //нужно чтобы отрабатыввало переключение отображения каталога после фильтрации
    this.navBtn.off('click')
    $('[data-filter-href] .icon').off('click')
    this.navBtn.removeClass('active').prop("disabled", false);
    $(this.navBtn[0]).addClass('active').prop("disabled", true);

    let filters = [];
    if ($('[data-filter]').length > 0) {
      $('[data-filter]').each(function(i) {
        $( "body" ).off('click', '[data-filter-hide]', that.hideFilter)
        filters[i] = new Filter($(this));
        filters[i].initialize();
      });
    }
    //
    // let range = [];
    // if ($('[data-range]').length > 0) {
    //   $('[data-range]').each(function(i) {
    //     if ($(this)[i].noUiSlider) {
    //       range[i] = $(this)[i].noUiSlider;
    //     } else {
    //       range[i] = new RangeSlider($(this));
    //       range[i].initialize();
    //     }
    //   });
    // }

    let sliders = [];
    if ($('[data-slider]').length > 0) {
      $('[data-slider]').each(function(i) {
        sliders[i] = new Slider($(this));
        sliders[i].initialize();
      });
    }

    if (window.autoOpenSizes === true) {
      window.autoOpenSizes = false;
      $('[data-filter-size-shoes]').click();
    }

    if (typeof window.gtm_items !== 'undefined') {
      let gtmItemsShort = [];
      window.gtm_items.forEach(function(item) {
        gtmItemsShort.push({
          'google_business_vertical' : 'retail',
          'id'                       : item.id,
        });
      });
      dataLayer.push({
        'event' : 'view_item_list',
        'items' : gtmItemsShort
      });
      dataLayer.push({
        'ecommerce'                    : {
          'currencyCode' : 'KZT',
          'impressions'  : window.gtm_items
        },
        'event'                        : 'gtm-ee-event',
        'gtm-ee-event-action'          : 'Product Impressions',
        'gtm-ee-event-category'        : 'Enhanced Ecommerce',
        'gtm-ee-event-non-interaction' : 'True',
      });
    }
  }

  clearPagination(_url) {
    if (_url.indexOf('?') !== -1) {
      _url = _url.split('?');
      var saveParams = this.clearPaginationInParams(_url[1]);

      _url = _url[0] + '?';
      if (saveParams.length) {
        _url += saveParams + '&';
      }
    }

    return _url;
  }


  clearPaginationInParams(params) {
    var getParams = params.split('&');
    var saveParams = [];
    for (var _i in getParams) {
      var _one = getParams[_i].split('=');
      if (_one[0].indexOf('SHOWALL') === -1 && _one[0].indexOf('PAGEN') === -1) {
        saveParams.push(getParams[_i]);
      }
    }

    return saveParams.join('&');
  }

  // Получим цену из радиобатона и преобразуем в битриксовый вид
  preparePriceParams(params){
    let getParams = params.split('&');
    let saveParams = [];
    let priceItem = this.filter.find('input[data-minprice-name]');
    let minPriceName = 'arrCatalogFilter_P1_MIN';
    let maxPriceName = 'arrCatalogFilter_P1_MAX';

    if (priceItem.length > 0) {
      minPriceName = priceItem.first().attr('data-minprice-name');
      maxPriceName = priceItem.first().attr('data-maxprice-name');
    }

    for (var _i in getParams) {
      var _one = getParams[_i].split('=');
      if (_one[0].match(/.*filter_price/) !== null) {
        _one[1] = _one[1].replace(/%C2%A0/, '');
        let arPrice = _one[1].split('-');
        let minPrice = parseInt(arPrice[0].match(/\d+/))
        let maxPrice = parseInt(arPrice[1].match(/\d+/))
        let filterPriceMin = minPriceName+'='+minPrice;
        let filterPriceMax = maxPriceName+'='+maxPrice;
        saveParams.push(filterPriceMin);
        saveParams.push(filterPriceMax);
      } else {
        saveParams.push(getParams[_i]);
      }
    }

    return saveParams.join('&');
  }

  // удалим лишние пробелы от слайдера в строке параметров
  prepareRangeInParams(params) {
    var getParams = params.split('&');
    var saveParams = [];
    for (var _i in getParams) {
      var _one = getParams[_i].split('=');
      if (_one[0].match(/.*_MIN|.*_MAX/) !== null) {
        _one[1] = _one[1].replace(/%C2%A0/, '');
        let _one_join = _one.join('=');
        saveParams.push(_one_join);
      } else {
        saveParams.push(getParams[_i]);
      }

    }

    return saveParams.join('&');
  }

  addFilter(el) {
    let $el = $(el);
    let attr = $el.find('input').attr('name');
    let text = '';

    if(typeof attr == 'undefined' ){
      attr = el.getAttribute('name');
    }

    if ((el.getAttribute('type') == 'checkbox') || (el.getAttribute('type') == 'radio')) {
      text = $el.closest('label').text();
    } else {
      text = el.innerText;
    }

    let path = process.env.NODE_ENV === 'development' ? '/' : '/local/frontend/build/'

    let templete = `<div class="filter-result__item" data-filter-href="${attr}"><span>${text}</span><svg class="icon remove " aria-hidden="true"><use xlink:href="${path}assets/images/required/sprite.svg#remove"></use></svg></div>`;

    let filterInputContainer = $el.closest('[data-filter-button]');
    let filterInput = filterInputContainer.find('input');
    //если клик по цвету
    if($el.attr('data-filter-checkbox') == '' || $el.attr('data-filter-checkbox') == 'price'){
      filterInput = $el
    }

    if (el.classList.contains('selected') && $el.attr('data-filter-range') != 'Y' && filterInput.attr('data-checked') != '1' || $('[data-page-content]').attr('data-load-page') == 'N') {
      this.result.children('[data-filter-result-list]').append(templete)
      if (filterInput !== null) {
        filterInput.attr('checked', 'checked');
      }
    } else {
      if (filterInput !== null) {
        filterInput.removeAttr('checked');
      }

      let res = this.result.find(`[data-filter-href='${attr}']`);

      if (res.length > 0) {
        res.remove();
      }
    }
  };

  // Слайдер цены Закоментирован
  // обработчик события 'end' слайдера цены
  // обновляет фильтр и список товаров
  // sliderEndEventHandler(slider) {
  //   slider.inputs.forEach((el) => {
  //     el.classList.toggle('selected');
  //     this.addFilter(el);
  //   });
  //
  //   this.isReset();
  //   this.applyFilter();
  // }

  checkSizeFilter() {
    var _modal = $('#sizeFilterModal');

    $('[data-size-popup]').off('click').on('click', function() {
      _modal.find('.btns').html('');

      $('.prop_SEX').each(function() {
        var _input = $(this);
        var _text = $.trim(_input.parent().find('span').text());

        _modal.find('.btns').append('<div class="filter__content-item"><div class="filter__content-button" data-id="' + _input.attr('id') + '"><span>' + _text + '</span></div></div>');
      });

      _modal.find('.btns .filter__content-button').on('click', function() {
        window.autoOpenSizes = true;

        $('#' + $(this).data('id')).click();

        $.magnificPopup.close();

        return false;
      });

      $.magnificPopup.open({
        items: {
          src: '#sizeFilterModal'
        },
        type:'inline',
        midClick: true,
        closeMarkup: '<button title="%title%" type="button" class="mfp-close popup__close close"></button>',
        removalDelay: 500, //delay removal by X to allow out-animation
        callbacks: {
          beforeOpen: function() {
            this.st.mainClass = 'mfp-zoom-in';
          }
        }
      });

      return false;
    });
  }
}

export {Filter};

$(window).on('load', () => {
  window.filters = [];

  if ($('[data-filter]').length > 0) {
    $('[data-filter]').each(function(i) {
      window.filters[i] = new Filter($(this));
      window.filters[i].initialize();
    });
  }
});
